import { render, staticRenderFns } from "./HowToPayModal.vue?vue&type=template&id=07f06102"
import script from "./HowToPayModal.vue?vue&type=script&lang=js"
export * from "./HowToPayModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports